/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import PaginationXs from 'bundles/grading/components/common/PaginationXs';
import Submitter from 'bundles/grading/components/staff-graded-assignments/left-panel/Submitter';
import type { SGASubmitter } from 'bundles/grading/components/staff-graded-assignments/types/SGAGradingTypes';

import _t from 'i18n!nls/grading';

type Props = {
  items: SGASubmitter[];
  current?: SGASubmitter | null;
};

const styles = {
  listContainer: () => css`
    height: 100%;
    display: flex;
    flex-flow: column;
  `,
  list: () => css`
    padding: 0;
    margin: 0 var(--cds-spacing-200);
    flex-grow: 1;
    overflow-y: auto;
  `,
  pagination: () => css`
    padding: var(--cds-spacing-200);
    background-color: var(--cds-color-neutral-background-primary);
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  `,
};

const PAGE_SIZE = 10;

const getPageOfSelectedItem = (items: SGASubmitter[], id?: string) => {
  if (!id) {
    return 1;
  }
  const index = items.findIndex((item) => item.id === id);
  return index === -1 ? 1 : Math.ceil((index + 1) / PAGE_SIZE);
};

// Component for list of submitters for a specific group
const SubmitterListGroup: React.FC<Props> = ({ items, current }) => {
  const initialPage = getPageOfSelectedItem(items, current?.id);
  const [page, setPage] = useState(initialPage);
  const total = items.length;

  const pageItems = items.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // update page on filter change
  useEffect(() => {
    const newPage = getPageOfSelectedItem(items, current?.id);
    setPage(newPage);
  }, [items, current?.id]);

  return (
    <div css={styles.listContainer}>
      <ul css={styles.list} aria-label={_t('Submitter list')}>
        {pageItems.map((item) => {
          return (
            <Submitter key={`submitter-${item.id}`} submitter={item} isSelectedSubmitter={item.id === current?.id} />
          );
        })}
      </ul>
      <div css={styles.pagination}>
        <PaginationXs page={page} pageSize={PAGE_SIZE} total={total} onPageChange={setPage} />
      </div>
    </div>
  );
};

export default SubmitterListGroup;
